var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAuditTrail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1522 16.2466L12.7222 19.6766V8.29663C14.2522 7.95663 15.3922 6.59663 15.3922 4.96663C15.3922 3.07663 13.8622 1.54663 11.9722 1.54663C10.0822 1.54663 8.55219 3.07663 8.55219 4.96663C8.55219 6.59663 9.70219 7.95663 11.2222 8.29663V19.6666L7.80219 16.2466L6.74219 17.3066L11.9722 22.5366L17.2122 17.2966L16.1522 16.2366V16.2466ZM10.0522 4.96663C10.0522 3.90663 10.9122 3.04663 11.9722 3.04663C13.0322 3.04663 13.8922 3.90663 13.8922 4.96663C13.8922 6.02663 13.0322 6.88663 11.9722 6.88663C10.9122 6.88663 10.0522 6.02663 10.0522 4.96663Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuditTrail);
export default __webpack_public_path__ + "static/media/ic-audit-trail.e06ec25e380c232bf1f8f13b1f9159fe.svg";
export { ForwardRef as ReactComponent };